import React from 'react';

class HighLightBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [{img: require('assets/images/fair/business1.png')},
      {img: require('assets/images/fair/business2.png')},
      {img: require('assets/images/fair/business3.png')},
      {img: require('assets/images/fair/business4.png')},
      {img: require('assets/images/fair/business1.png')},
      {img: require('assets/images/fair/business2.png')},
      {img: require('assets/images/fair/business3.png')},
      {img: require('assets/images/fair/business4.png')},
      {img: require('assets/images/fair/business1.png')},
      {img: require('assets/images/fair/business2.png')},
      {img: require('assets/images/fair/business3.png')},
      {img: require('assets/images/fair/business4.png')}]
    }
  }

  render() {
    return (
      <section className="fair-highllight-business-container">
        <h2 className='fair-highllight-business-title'>Các doanh nghiệp tiêu biểu</h2>
        <div className='fair-highllight-business-list-item'>
          {
            this.state.data.map((business, i) => {
              return(
                <div className='fair-highllight-business-item-wrap' key={i}>
                  <img className='fair-highllight-business-img' src={business.img}/>
                </div>
              )
            })
          }
        </div>
      </section>
    );
  }
}

export default HighLightBusiness;


// WEBPACK FOOTER //
// ./components/fair/sub-view/business/HighLightBusiness.jsx